// React and Redux imports
import { useDispatch, useSelector } from 'react-redux';

// Chakra UI components
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

// Actions and constants
import { deleteSubQuestProgressionSessionsAction } from 'store/modules/subQuestReport/subQuest-report-action';
import { subQuestReportActions } from 'store/modules/subQuestReport/subQuest-report-slice';
import { ReducerStatus } from 'utils/constants';

// Common components
import ResultModal from 'components/common/modals/ResultModal';

function DeleteProgressionSessionMd() {
  const dispatch = useDispatch();

  // Select delete progression state from Redux store
  const deleteProgressionSession = useSelector(
    (state) => state.subQuestReport.deleteProgressionSession
  );

  // Function to toggle the delete progression modal
  const handleToggleDeleteModal = (isOpen) => {
    dispatch(subQuestReportActions.toggleDeleteProgressionSessionModal(isOpen));
  };

  // Function to dispatch the delete action for sub-quest progression session
  const handleDeleteSubQuestProgressionSession = () => {
    dispatch(
      deleteSubQuestProgressionSessionsAction({
        sessionId: deleteProgressionSession.sessionId,
        subQuestId: deleteProgressionSession.subQuestId,
        progressionId: deleteProgressionSession.progressionId,
      })
    );
  };

  // Function to reset the delete progression status after result modal interaction
  const handleResultButton = () => {
    dispatch(subQuestReportActions.resetDeleteProgressionSessionStatus());
  };

  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {deleteProgressionSession.status === ReducerStatus.SUCCEEDED ||
      deleteProgressionSession.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={deleteProgressionSession.modal}
          onSubmit={handleResultButton}
          isError={deleteProgressionSession.status === ReducerStatus.FAILED}
          title={
            deleteProgressionSession.status === ReducerStatus.SUCCEEDED
              ? 'Deleted'
              : 'Server Error'
          }
          message={
            deleteProgressionSession.status === ReducerStatus.SUCCEEDED
              ? 'The selected session has been deleted successfully. If you believe this was done in error, please contact the administrator.'
              : deleteProgressionSession.error?.data?.title || 'Server Error'
          }
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal
          isOpen={deleteProgressionSession.modal}
          onClose={() => handleToggleDeleteModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you certain you want to delete this session?
            </ModalBody>

            <ModalFooter>
              {/* Close button */}
              <Button
                colorScheme="gray"
                mr={3}
                onClick={() => handleToggleDeleteModal(false)}
              >
                Close
              </Button>
              {/* Proceed button */}
              <Button
                colorScheme="red"
                isLoading={
                  deleteProgressionSession.status === ReducerStatus.LOADING
                }
                onClick={handleDeleteSubQuestProgressionSession}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default DeleteProgressionSessionMd;
